import { TransactionDetailDto } from "@admin_api/models/transaction-detail-dto";

export class TransactionState {
    loading = false;
    error = null;
    record: TransactionDetailDto = {};
}
